module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "start"
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wow fadeInUp",
    attrs: {
      "data-wow-duration": "1s",
      "data-wow-delay": "0"
    }
  }, [_c('div', {
    staticClass: "bookmark"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/v/start.svg"),
      "alt": "故事緣起"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "startpic startpic1 wow5"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/start_pic1.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txtcontent strip"
  }, [_c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/start1.svg"),
      "alt": "說一說我們的初心"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "wow2"
  }, [_vm._v(" 20年前，"), _c('b', [_vm._v("韓淑華")]), _vm._v("老師遇見一群愛畫畫的孩子"), _c('br', {
    staticClass: "desktop_only"
  }), _vm._v("他們充滿生命力、跳出一般框架的創作，深深打動她"), _c('br'), _c('br'), _vm._v("對一般人再自然不過的行為和情感，"), _c('br'), _vm._v("對這群「泛自閉症的孩子」而言，"), _c('br', {
    staticClass: "m_only"
  }), _vm._v("是10倍-100倍的困難"), _c('br'), _c('br'), _vm._v("但，繪畫創作一路陪伴著，點亮他們的神采"), _c('br'), _c('br'), _vm._v("「未來能繼續不停地畫畫嗎？創作能不能也是一份工作？」")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "startpic startpic2"
  }, [_c('img', {
    staticClass: "wow1",
    attrs: {
      "src": require("../../img/start_pic2.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txtcontent txt"
  }, [_c('p', {
    staticClass: "wow4"
  }, [_c('br'), _vm._v("這裡讓「泛自閉症創作人」勇敢地繼續創作，"), _c('br'), _vm._v("以他們的藝術能力得到基本的收入"), _c('br'), _c('br'), _vm._v("以最精彩的一面活著，也讓這個世界因著他們的特別，更豐富而美麗")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "loofahcontent"
  }, [_c('div', {
    staticClass: "loofahleaf"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/loofah/loofahleaf.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loofah"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/loofah/loofah.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b3d861d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Start.vue
// module id = 256
// module chunks = 0